// import LayoutNews from "@/layouts/LayoutNews";
import LayoutArticle from "@/layouts/LayoutArticle.vue";

export default [{
  path: "/lianzheng",
  name: "lianzheng",
  meta: {
    title: "廉政建设",
    icon: require('@/assets/images/icons/lianzhneg.png')
  },
  component: () => import("@/views/lianzheng/index.vue"),
  // component: LayoutNews,
  // redirect: "/lianzheng/fagui",
  children: [{
    path: "/lianzheng/fagui",
    name: "廉政政策法规",
    meta: {
      title: "廉政政策法规",
      icon: require('@/assets/images/icons/lianzhneg.png')
    },
    component: () => import("@/views/lianzheng/components/fagui.vue"),
  },
  {
    path: "/lianzheng/tousu",
    name: "tousu",
    meta: {
      title: "举报投诉",
      icon: require('@/assets/images/icons/lianzhneg.png')
    },
    component: () => import("@/views/lianzheng/components/tousu.vue"),
  },
  ],
}, {
  path: "/lianzheng-detail",
  name: "lianzheng-detail",
  meta: {
    title: "廉政建设",
    hidden: true,
    icon: require('@/assets/images/icons/lianzhneg.png')
  },
  component: LayoutArticle,
  redirect: "/lianzheng/detail",
  children: [{
    path: "/lianzheng/detail",
    name: "lianzheng_detail",
    meta: {
      title: "文章详情",
      hidden: true,
    },
    component: () => import("@/views/lianzheng/detail.vue"),
  },],
},]